const BgQuotes = ({
  className,
  fill,
}: {
  className?: string;
  fill?: string;
}) => {
  return (
    <svg
      width="96"
      height="69"
      viewBox="0 0 96 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none`}
    >
      <path
        d="M94.9027 21.9545L94.9027 21.97L94.9032 21.9855L95 25.1063C94.9919 48.4675 76.465 67.4531 53.4255 67.9884L53.4255 57.4393C61.6323 57.188 69.3143 53.8469 75.1437 47.9727L75.1438 47.9727C76.3109 46.7964 77.3762 45.5448 78.3372 44.2301L79.768 42.2725L77.3732 42.6523C76.3117 42.8206 75.2239 42.9091 74.1155 42.9091C62.6422 42.9091 53.3282 33.5345 53.3282 21.9545C53.3282 10.3746 62.6422 0.999995 74.1155 0.999994C85.5888 0.999993 94.9027 10.3746 94.9027 21.9545ZM42.5745 21.9545L42.5745 21.97L42.575 21.9855L42.6718 25.1063C42.6636 48.4675 24.1369 67.4531 1.09727 67.9884L1.09727 57.4393C9.30392 57.188 16.9863 53.8469 22.8155 47.9727C23.9829 46.7964 25.0482 45.5448 26.0092 44.2301L27.44 42.2725L25.0452 42.6523C23.9837 42.8206 22.8959 42.9091 21.7873 42.9091C10.3141 42.9091 1 33.5345 1 21.9545C1 10.3746 10.3141 1 21.7873 0.999999C33.2604 0.999998 42.5745 10.3746 42.5745 21.9545Z"
        stroke={fill || "#E3E4FF"}
        strokeWidth="2"
      />
    </svg>
  );
};

export default BgQuotes;
